import React from 'react'
import Mpt from 'react-moment-proptypes'
import moment from 'moment'

import Ago from './Ago'

export default class UpdatingAgo extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      duration: this.getDiff(this.props.moment),
    }
    this.timeout = null
  }

  componentDidMount() {
    this.runTimeout()
  }

  componentDidUpdate() {
    this.runTimeout()
  }

  componentWillUnmount() {
    clearTimeout(this.timeout)
  }

  getDiff = date => moment.duration(date.diff(this.props.now))

  runTimeout = () => {
    clearTimeout(this.timeout)

    const timeout = Math.abs(this.state.duration.asMilliseconds())
    if (timeout > 8.64e7) {
      return
    }

    this.timeout = setTimeout(() => {
      this.setState({
        duration: this.getDiff(this.props.moment),
      })
    }, timeout)
  }

  render() {
    return <Ago duration={this.props.moment} />
  }
}

UpdatingAgo.defaultProps = {
  now: moment(),
}

UpdatingAgo.propTypes = {
  moment: Mpt.momentObj.isRequired,
  now: Mpt.momentObj,
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/components/Time/UpdatingAgo.jsx